// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15Gn_","expireSoon":"styles_expireSoon__30HMd"};